import React, {useEffect, useMemo, useRef, useState} from 'react';
import './PlayerPositionFilterBar.style.scss';
import SideScroller from "../SideScroller/SideScroller";

const PlayerPositionFilterBar = ({vm}) => {

    const selectedPosition = vm.filters.position;

    const positions = useMemo(()=>{
        return [...new Set(vm.preFilteredContests.map( c=>c.player.Position ))];
    },[vm.filters, vm.viewData.lastUpdate])

    const handlePositionClick = (position)=>{
        const value = position === selectedPosition ? null : position;
        vm.handleFilterChange("position", value);
    };


    return (
        <div className={`PlayerPositionFilterBarWrapper`}>
           <SideScroller>
            <div className="PlayerPositionFilterBar">
                <div className="positionFilter">
                    {positions.map((position, index) => (
                        <button
                            key={index}
                            className={(selectedPosition === position ? "active gold-gradient-border" : "") + " playerPosition"}
                            onClick={() => handlePositionClick(position)}>
                            {position}
                        </button>
                    ))}
                    <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                </div>
            </div>
           </SideScroller>
        </div>
    );
}

export default PlayerPositionFilterBar;